import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { BuilderDashboard } from '../../features/builders/builderDashboard.tsx';
import useAppStore from '../../store/rootStore.ts';
import { createPageBackgroundSx } from '../../styles/pageBackground.ts';

export const Route = createFileRoute('/builders/dashboard')({
  component: BuilderDashboardPage,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.showBuildersFundingHistory) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const builderDashboardPageSx = createPageBackgroundSx();

function BuilderDashboardPage() {
  return (
    <Stack sx={builderDashboardPageSx}>
      <BuilderDashboard />
    </Stack>
  );
}
